// Routes that render inside an <iframe> on a customer's own website.
//
// Widgets, forms and surveys get there through `js-snippet/embed.js`, which builds
// `${APP_BASE_URL}/${type}s/${id}` iframes. Wall of love and review booster are
// embedded by hand from their own URLs, so they are not discoverable from the
// snippet but land in exactly the same place.
//
// Anything loaded on these routes runs on another company's page, in front of
// their visitors, so keep third-party marketing scripts out. Sentry is the
// deliberate exception: it is sampled down in sentry.client.config.js and is how
// widget rendering bugs on customer sites get reported at all.
// /domain-not-connected is what a customer's own domain shows when it is not connected to a page.
const EMBEDDED_PATH_PREFIXES = ['/widgets', '/forms', '/surveys', '/wall-of-love', '/booster', '/domain-not-connected'];

export default function isEmbeddedPath(pathname) {
  if(!pathname) {
    return false;
  }
  return EMBEDDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
